import { ref } from 'vue';
import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';
import { route } from '@router/router';

export interface PtiModuleUsageType {
    conversion: number;
    event: number;
    heatmap: number;
}

const GET_PTI_USAGE_QUERY = gql`
    query getProfileUsedForPtengine($where: ProfileWhereUniqueInput!) {
        getProfileUsedForPtengine(where: $where) {
            sid
            heatmap
            event
            conversion
        }
    }
`;

const ptiModuleUsage = ref<PtiModuleUsageType | undefined>();
const ptiModuleUsageLoading = ref(false);

export function usePtiUsage() {
    const getPtiUsage = (params?: {
        sid?: string;
        resultCallback?: (T: PtiModuleUsageType) => void;
        rejectCallback?: (err: any) => void;
        finallyCallback?: (T: any) => void;
    }) => {
        const profileId = params?.sid || route.value?.params?.sid;
        if (!profileId) return;
        ptiModuleUsageLoading.value = true;
        const { onResult, onError } = useQuery<{ getProfileUsedForPtengine: PtiModuleUsageType }>(
            GET_PTI_USAGE_QUERY,
            {
                where: { sid: profileId }
            },
            {
                fetchPolicy: 'no-cache'
            }
        );

        onResult(data => {
            if (data?.data?.getProfileUsedForPtengine) {
                ptiModuleUsage.value = data?.data?.getProfileUsedForPtengine || {};
                ptiModuleUsageLoading.value = false;
                params?.resultCallback &&
                    typeof params?.resultCallback === 'function' &&
                    params?.resultCallback(data.data.getProfileUsedForPtengine);
                params?.finallyCallback &&
                    typeof params?.finallyCallback === 'function' &&
                    params?.finallyCallback(data.data.getProfileUsedForPtengine);
            }
        });

        onError(err => {
            ptiModuleUsage.value = undefined;
            ptiModuleUsageLoading.value = false;
            params?.rejectCallback &&
                typeof params?.rejectCallback === 'function' &&
                params?.rejectCallback(err);
            params?.finallyCallback &&
                typeof params?.finallyCallback === 'function' &&
                params?.finallyCallback(err);
        });
    };

    return {
        ptiModuleUsage,
        ptiModuleUsageLoading,
        getPtiUsage
    };
}
